import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getStoreDetail(params) {
	return client.get("seller/store/detail", {
		params: params,
	});
}

function getStoreDetailAdmin(params) {
	return client.get("seller/store_admin/detail", {
		params: params,
	});
}

function updateStore(params) {
	return client.post("seller/store/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateStoreCourier(params) {
	return client.post("seller/store/edit-courier", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateStoreBank(params) {
	return client.post("seller/store/edit-bank", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function uploadImage(params) {
	return client.post("seller/store/upload-image", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

function saveDescription(params) {
	return client.post("seller/store/edit-description", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function saveKurirTokoStatus(params) {
	return client.post("seller/store/update-store-courier-status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function saveKurirTokoDetail(params) {
	return client.post("seller/store/update-store-courier", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getStoreDetail,
	updateStore,
	saveKurirTokoDetail,
	saveKurirTokoStatus,
	updateStoreCourier,
	updateStoreBank,
	uploadImage,
	saveDescription,
	getStoreDetailAdmin
};